import React from 'react';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { ClientType } from '@common/model/client/clientType';
import {
  CatalogBannerSearchProps as CatalogBannerSearchEntityProps,
  CatalogBannerSearch as CatalogBannerSearchForVacancyEntity,
} from 'src/entities/catalog/banner';
import { useAuthWithQuiz } from 'src/features/auth';
import { SelectionType, useClientSelectionService } from 'src/features/clientSelection';

export type CatalogBannerSearchForVacancyProps = Omit<CatalogBannerSearchEntityProps, 'onClick' | 'itemType'>;

export const CatalogBannerSearchForVacancy: React.FC<CatalogBannerSearchForVacancyProps> = (props) => {
  const clientSelection = useClientSelectionService();
  const startRegistrationForSpecialist = useAuthWithQuiz(['careerId']);

  return (
    <CatalogBannerSearchForVacancyEntity
      itemType={CatalogItemType.Vacancy}
      {...props}
      onClick={() => {
        clientSelection.register({ clientType: ClientType.Specialist }, SelectionType.ClientAction);
        startRegistrationForSpecialist();
      }}
    />
  );
};
